<template>
    <div ref="el" class="overflow-y-auto hide-scrollbar overscroll-contain">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { toRefs, ref, watch } from 'vue';
import { useScroll } from '@vueuse/core';

const emit = defineEmits<{
    (event: 'arrivedLeft', content: boolean): void;
    (event: 'arrivedRight', content: boolean): void;
    (event: 'arrivedTop', content: boolean): void;
    (event: 'arrivedBottom', content: boolean): void;
}>();

const el = ref<HTMLElement | null>(null);

const { arrivedState } = useScroll(el);
const { left, right, top, bottom } = toRefs(arrivedState);

watch([left, right, top, bottom], () => {
    if (left.value) {
        emit('arrivedLeft', true);
    }

    if (right.value) {
        emit('arrivedRight', true);
    }

    if (top.value) {
        emit('arrivedTop', true);
    }

    if (bottom.value) {
        emit('arrivedBottom', true);
    }
});
</script>
